import React, { useState } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { AuthContextProvider } from './context/AuthContext';
import ProfileContext from './context/ProfileContext';
import Layout from './pages/Layout';
import Signin from './pages/Signin';
import { Mobile } from './pages/Mobile';
import ErrorBoundary from './components/ErrorBoundary';
import { UserProvider } from './context/UserContext';
import { StepProvider } from './context/StepContext';

function ScrollToTop() {
  const { pathname } = useLocation();

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  const [profile, setProfile] = useState({ currentCompany: '', totalExperience: 0 });

  const value = React.useMemo(() => ({ profile, setProfile }), [profile]);

  return (
    <ErrorBoundary>
      <UserProvider>
        <AuthContextProvider>
          <ProfileContext.Provider value={value}>
            <StepProvider>
              <ScrollToTop />
              <Routes>
                <Route path='/' element={<Signin />} />
                <Route path="*" element={<Layout />} />
                <Route path='/mobile' element={<Mobile />} />
              </Routes>
            </StepProvider>
          </ProfileContext.Provider>
        </AuthContextProvider>
      </UserProvider>
    </ErrorBoundary>
  );
}

export default App;
